"use client";

import React from "react";
import {cn} from "@/lib/utils";

export default function DividerGreenLine({
  className = "",
  greenLineClassName = "",
}: {
  className?: string;
  greenLineClassName?: string;
}) {
  return (
    <div className={cn(
      "h-[0.125rem] relative bg-white bg-opacity-20",
      className
    )}>
      <div
        className={cn(
          "absolute h-full left-1/2 -translate-x-1/2 w-[30%] bg-[#D9F9B9]",
          greenLineClassName,
        )}
      />
    </div>
  );
}
